<!-- 预定说明组件 -->
<template>
	<div class="costBox" v-if="JSON.stringify(datas) !== '{}'">
		<div v-if="state == 3 || state == 5 || state == 9">
			<div class="column" v-for="(item, index) in costObj[state]" :key="index + 'costObj'">
				<div class="columnText2" style="width: 1.4rem;">
					{{ item.title }}
				</div>
				<el-input :disabled="disabled" size="small" :value="datas.otherStockData[item.code]" class="columnText3"
					placeholder-class="placeholder" style="flex: 1;padding-left: 20rpx;" :placeholder="item.placeholder"
					type="text"></el-input>
			</div>
			<div v-if="state == 9" class="column">
				<div class="columnText4">
					哪些费用需要单独支付
				</div>
			</div>
			<div class="column" v-for="(item, index) in costObj1[state]" :key="index + 'costObj1'">
				<div class="columnText2" style="width: 0.9rem;text-align: left;">
					{{ item.title }}
				</div>
				<div style="display: flex;align-items: center;margin-right: 0.25rem">
					<el-radio :disabled="disabled" size="medium" @click="handlerSelectClick(1)"
						v-model="datas.otherStockData[item.code1]" :label="0">&nbsp;</el-radio>
					<span class="columnText2">{{ item.text[0] }}</span>
				</div>
				<div style="display: flex;align-items: center;margin-right: 0.2rem">
					<el-radio :disabled="disabled" size="medium" @click="handlerSelectClick(1)"
						v-model="datas.otherStockData[item.code1]" :label="1">&nbsp;</el-radio>
					<span class="columnText2">{{ item.text[1] }}</span>
				</div>
				<el-input :disabled="disabled" size="small" :value="datas.otherStockData[item.code]" class="columnText3"
					placeholder-class="placeholder" style="flex: 1;" :placeholder="item.placeholder" type="text"></el-input>
			</div>
			<div class="column">
				<div class="columnText4">
					杂费是否包含在报价内
				</div>
			</div>
		</div>
		<div class="column">
			<div class="columnText2">
				是否含commission
			</div>
			<div class="columnText3" style="text-align: center;flex: 1;">{{ datas.isCommission != null && datas.isCommission
				!= undefined
				? isVatList[datas.isCommission] :
				'未填写' }}</div>
			<div v-if="datas.isCommission == 1" style="display: flex;align-items: center;width: 2.6rem;">
				<div class="columnText2" style="margin-right: 0.1rem;">
					commission金额：{{ datas.vatPrice ? datas.vatPrice : '未填写' }}
				</div>
				<div class="columnText2">
					币种：<span class="columnText3">{{ datas.prices[0].currency ? datas.prices[0].currency : '未填写' }}</span>
				</div>
			</div>
		</div>
		<div class="column">
			<div class="columnText2">
				是否含VAT
			</div>
			<div class="columnText3" style="flex: 1;text-align: center;">{{ datas.isVat != null && datas.isVat != undefined
				? isVatList[datas.isVat] :
				'未填写' }}</div>
			<div v-if="datas.isVat == 1" style="display: flex;align-items: center;flex: 1;">
				<div class="columnText2" style="margin-right: 0.1rem;">
					VAT金额：{{ datas.vatPrice ? datas.vatPrice : '未填写' }}
				</div>
				<div class="columnText2">
					币种：<span class="columnText3">{{ datas.prices[0].currency ? datas.prices[0].currency : '未填写' }}</span>
				</div>
			</div>
		</div>
		<div class="column">
			<div class="columnText2">
				是否含城市税
			</div>
			<div style="flex: 1;text-align: center;">
				<div class="columnText3" style="flex: 1;">
					{{ datas.isCityTax != null && datas.isCityTax != undefined ? isTaxList[datas.isCityTax] : '未填写' }}
				</div>
			</div>
			<div style="flex: 1;display: flex;align-items: center;" v-if="datas.isCityTax == 1">
				<div class="columnText2" style="margin-right: 0.1rem;">
					城市税金：{{ datas.cityTaxPrice ? datas.cityTaxPrice : '未填写' }}
				</div>
				<div class="columnText2">
					币种：<span class="columnText3">{{ datas.prices[0].currency ? datas.prices[0].currency : '未填写' }}</span>
				</div>
			</div>
		</div>
		<div class="column" v-if="state == 0">
			<div class="columnText2">
				报价含早餐
			</div>
			<div style="flex: 1;text-align: center;" class="columnText3"><span class="columnText2">早餐数量：</span>{{
				datas.otherStockData.breakfastNum ? datas.otherStockData.breakfastNum : 0 }} <span
					class="columnText2">份</span></div>
			<div style="flex: 1;" class="columnText3"> <span class="columnText2">备注：</span>{{
				datas.otherStockData.breakfastRemark ? datas.otherStockData.breakfastRemark : '未填写' }}
			</div>
		</div>
		<div>
			<div class="column" style="background-color:rgba(250, 250, 250, 1);">
				<div class="columnTitle">
					价格内<span class="columnText4">包含</span>的设施和服务
				</div>
			</div>
			<div v-for="(item, index) in datas.contains[2]" :key="index + 'contains2'">
				<div class="column">
					<div class="columnText5">
						设施名称
					</div>
					<el-input :disabled="disabled" size="small" v-model="item.name" class="columnText3" style="width: 3rem;"
						placeholder="请点击输入设施名称" type="text"></el-input>
					<el-input :disabled="disabled" style="width: 0.7rem;" size="small" v-model="item.number"
						class="columnText3" placeholder="0" type="text"></el-input>
					<span class="columnText2">份</span>
				</div>
				<div class="column">
					<div class="columnText2">
						设施备注
					</div>
					<el-input :disabled="disabled" style="width: 4.12rem;" size="small" v-model="item.containDescribe"
						class="columnText3" placeholder="请填写设施材质尺寸等描述" type="text"></el-input>
				</div>
			</div>
			<div v-for="(item, index) in datas.contains[1]" :key="index + 'contains1'">
				<div class="column" :style="[index == 0 ? { borderTop: '1px dotted #496878' } : '']">
					<div class="columnText5">
						服务名称
					</div>
					<el-input :disabled="disabled" size="small" v-model="item.name" class="columnText3" style="width: 3rem;"
						placeholder="请点击输入服务名称" type="text"></el-input>
					<el-input :disabled="disabled" style="width: 0.7rem;" size="small" v-model="item.number"
						class="columnText3" placeholder="0" type="text"></el-input>
					<span class="columnText2">份</span>
				</div>
				<div class="column">
					<div class="columnText2">
						服务备注
					</div>
					<el-input :disabled="disabled" style="width: 4.12rem;" size="small" v-model="item.containDescribe"
						class="columnText3" placeholder="请填写服务标准等描述" type="text"></el-input>
				</div>
			</div>
		</div>
		<div>
			<div class="column" style="background-color:rgba(250, 250, 250, 1);">
				<div class="columnTitle">
					价格内<span class="columnText4">不含</span>的设施和服务
				</div>
			</div>
			<div v-for="(item, index) in datas.contains[4]" :key="index + 'contains4'">
				<div class="column">
					<div class="columnText5">
						设施名称
					</div>
					<el-input :disabled="disabled" size="small" v-model="item.name" class="columnText3" style="width: 3rem;"
						placeholder="请点击输入设施名称" type="text"></el-input>
					<el-input :disabled="disabled" style="width: 0.7rem;" size="small" v-model="item.number"
						class="columnText3" placeholder="0" type="text"></el-input>
					<span class="columnText2">份</span>
				</div>
				<div class="column" style="padding-right: 60rpx;">
					<div class="columnText2">
						额外付费
					</div>
					<el-input :disabled="disabled" size="small" v-model="item.price" class="columnText3"
						style="width: 1rem;text-align: center;" placeholder="0" type="text"></el-input>
					<span class="columnText2">货币</span>
					<div class="columnText3">
						{{ item.currency ? item.currency : '¥' }}
					</div>
					<span class="columnText2">/份</span>
				</div>
				<div class="column">
					<div class="columnText2">
						设施备注
					</div>
					<el-input :disabled="disabled" style="width: 4.12rem;" size="small" v-model="item.containDescribe"
						class="columnText3" placeholder="请填写设施材质尺寸等描述" type="text"></el-input>
				</div>
			</div>
			<div v-for="(item, index) in datas.contains[3]" :key="index + 'contains3'">
				<div class="column" :style="[index == 0 ? { borderTop: '1px dotted #496878' } : '']">
					<div class="columnText5">
						服务名称
					</div>
					<el-input :disabled="disabled" size="small" v-model="item.name" class="columnText3" style="width: 3rem;"
						placeholder="请点击输入服务名称" type="text"></el-input>
					<el-input :disabled="disabled" style="width: 0.7rem;" size="small" v-model="item.number"
						class="columnText3" placeholder="0" type="text"></el-input>
					<span class="columnText2">份</span>
				</div>
				<div class="column" style="padding-right: 60rpx;">
					<div class="columnText2">
						额外付费
					</div>
					<el-input :disabled="disabled" size="small" v-model="item.price" class="columnText3"
						style="width: 1rem;text-align: center;" placeholder="0" type="text"></el-input>
					<span class="columnText2">货币</span>
					<el-input :disabled="disabled" size="small" v-model="item.price" class="columnText3"
						style="width: 1rem;text-align: center;" placeholder="0" type="text"></el-input>
					<span class="columnText2">货币</span>
					<div class="columnText3">
						{{ item.currency ? item.currency : '¥' }}
					</div>
					<span class="columnText2">/份</span>
				</div>
				<div class="column">
					<div class="columnText2">
						服务备注
					</div>
					<el-input :disabled="disabled" style="width: 4.12rem;" size="small" v-model="item.containDescribe"
						class="columnText3" placeholder="请填写服务标准等描述" type="text"></el-input>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { costObj, costObj1 } from '../../../commodity'
export default {
	props: {
		state: {
			type: Number,
			default: 0
		},
		datas: {
			type: Object,
			default: {}
		},
		disabled: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			costObj,
			costObj1,
			isVatList: ['是', '否'], //是否含vat
			isTaxList: ['包含城市稅', '不包含城市稅', '没有城市稅'], //是否含城市稅
			currencyList: []
		}
	},
	methods: {

	},
}
</script>
<style lang="scss" scoped>
.costBox {
	border-radius: 0.05rem;
	background-color: rgba(250, 250, 250, 1);
	padding: 0 0.1rem;

	.column {

		height: 0.4rem;
		border-top: 1px dotted #E9E9E9;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.columnTitle {
			font-weight: bold;
			font-size: 0.16rem;
		}

		&:nth-child(1) {
			border-top: none;
			height: 0.4rem;
		}

		.columnText1 {
			color: #000000;
			font-size: 0.15rem;
			text-align: center;
		}

		.columnText2 {
			color: rgba(149, 144, 144, 1);
			font-size: 0.15rem;
		}

		.columnText3 {
			color: #000000;
			font-size: 0.15rem;
		}

		.columnText4 {
			color: rgba(230, 74, 25, 1);
			font-size: 0.15rem;
		}

		.columnText5 {
			color: rgba(43, 43, 43, 1);
			font-size: 0.15rem;
		}

	}
}
</style>
